import type { components } from "../api/types";

// 0038: the product's own words for the four things the app's text names from
// the product's world - who builds it from the spec, what is built, who it is
// for, and the first finished version of it the spec covers (the
// app's "first version") - served on the tree's meta (product_words) and,
// without its system-internal basis, on the spec read's meta, named by the
// engine from its understanding of the idea. New app text that names one of
// them reads it through productWord, never a hard-coded noun (as the spec
// column's third filter and the spec drawer's detail heading do, 0051
// slice 3); until a pass has named them, the generic word shows.
// models.ProductWordOf is the Go side;
// trace-invariant T32 pins the slot keys and the generic words below to it.

export type ProductWords = NonNullable<components["schemas"]["TreeMeta"]["product_words"]>;
export type ProductWordSlot = "who_builds_it" | "what_is_built" | "who_uses_it" | "what_is_built_first";
export type ProductWordForm = "one" | "many";

export const GENERIC_PRODUCT_WORDS: Record<ProductWordSlot, { one: string; many: string }> = {
  who_builds_it: { one: "builder", many: "builders" },
  what_is_built: { one: "product", many: "products" },
  who_uses_it: { one: "person", many: "people" },
  what_is_built_first: { one: "first version", many: "first versions" },
};

// The one function that words a slot: the served word, trimmed, or the generic
// word when the product has none yet (no words, or a blank form). It takes the
// tree meta's words or the spec read's (the four slots, no basis).
export function productWord(
  words: Pick<ProductWords, ProductWordSlot> | null | undefined,
  slot: ProductWordSlot,
  form: ProductWordForm = "one",
): string {
  const served = words?.[slot]?.[form];
  const v = typeof served === "string" ? served.trim() : "";
  return v !== "" ? v : GENERIC_PRODUCT_WORDS[slot][form];
}

// A word at the start of a label or sentence.
export function capitalized(word: string): string {
  return word.charAt(0).toUpperCase() + word.slice(1);
}
